<template>
  <div>
    <Hero></Hero>
    <Mission></Mission>
    <FAQ></FAQ>
    <HowItWorks></HowItWorks>
    <ReportPreview></ReportPreview>
    <GetInsights></GetInsights>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Hero from '@/components/Hero.vue';
import Mission from "@/components/Mission.vue";
import FAQ from "@/components/FAQ.vue";
import HowItWorks from "@/components/HowItWorks.vue";
import ReportPreview from "@/components/ReportPreview.vue";
import GetInsights from "@/components/GetInsights.vue";
import { mapGetters } from "vuex";

export default {
  name: 'Home',
  components: {
    Hero,
    Footer,
    Mission,
    FAQ,
    HowItWorks,
    ReportPreview,
    GetInsights,
  },
  computed: {
    ...mapGetters({
      bblId: 'get_bblId',
    }),
  },
  watch: {
    bblId(newVal) {
      if (newVal) {
        this.$router.push({ name: 'step', params: { id: newVal } });
      }
    }
  },
  created() {
    this.$store.commit('resetState')
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import "../scss/variables.scss";

</style>
